import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { Helmet } from 'react-helmet-async';
import './styles/Login.css';

const Login = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const { LogIn } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');
    if (storedUserId) {
      navigate('/profil');
    }
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { email, password } = formData;
    if (!email || !password) {
      alert('Tous les champs sont requis.');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!emailRegex.test(email)) {
      alert("L'adresse email n'est pas valide.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}/log-in`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
        credentials: 'include',
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Problème lors de la connexion.');
      }

      alert('Connexion réussie !');
      LogIn(data.userId);
      localStorage.setItem('user', JSON.stringify(true));
      localStorage.setItem('userId', data.userId);

      navigate('/profil');
    } catch (error) {
      console.error('Erreur lors de la connexion:', error);
      localStorage.removeItem('userId');
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login">
      <Helmet>
        <title>Connexion - WinlyDeal</title>
        <meta name="description" content="Connectez-vous à votre compte WinlyDeal pour participer à nos deals exclusifs et remporter vos produits préférés." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="login-container">
        <h1 className="login-title">Se connecter</h1>

        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-label" htmlFor="email">Adresse e-mail</label>
          <input
            type="email"
            id="email"
            name="email"
            className="login-input"
            placeholder="Entrez votre adresse e-mail"
            value={formData.email}
            onChange={handleInputChange}
            required
          />

          <label className="login-label" htmlFor="password">Mot de passe</label>
          <input
            type="password"
            id="password"
            name="password"
            className="login-input"
            placeholder="Entrez votre mot de passe"
            value={formData.password}
            onChange={handleInputChange}
            required
          />

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Connexion en cours...' : 'Se connecter'}
          </button>
        </form>

        <p className="login-footer">
          Pas encore inscrit ? <Link className="login-link" to="/signup">Créer un compte</Link>
        </p>
      </section>
    </main>
  );
};

export default Login;
